import { formatDistanceToNow } from 'date-fns';
import React from 'react';
import { TaskData } from '../../../api/endpoints/tasks';
import { Copy } from '../elements/LayoutElements';

export const TaskCreatedAtCell = React.memo(({ task }: { task: TaskData }) => {
    return <Copy size="0.9375" flush>{formatDistanceToNow(task.createdAt)} ago</Copy>;
});
